// extracted by mini-css-extract-plugin
export default {"container":"AllCountries_container__8HzfG"};